(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["newwvtjs"] && !Shopify.designMode) return;
  try {
    (() => {
    const config = document.getElementById('hs-wishlist-config');
    if (!config) return;
    const text = config.dataset;
    const root = text.root.endsWith('/') ? text.root : text.root + '/';
    const key = 'savedItem';
    const selector = '.wvtwisher[product_id][product_handler]';
    const listRoot = document.querySelector('.all-wishlistwvt');
    let generation = 0;
    let storageError = false;
    const read = () => {
      try {
        const value = JSON.parse(localStorage.getItem(key) || '[]');
        if (!Array.isArray(value)) throw new Error('Invalid wishlist');
        storageError = false;
        const unique = new Map();
        value.forEach(item => {
          if (item && /^\d+$/.test(String(item.ProductId)) && /^[a-z0-9-]+$/i.test(item.Producthandler)) {
            unique.set(String(item.ProductId), { ProductId: String(item.ProductId), Producthandler: item.Producthandler });
          }
        });
        return [...unique.values()];
      } catch (_) { storageError = true; return []; }
    };
    const updateButtons = items => {
      document.querySelectorAll(selector).forEach(button => {
        const selected = items.some(item => item.ProductId === button.getAttribute('product_id'));
        button.classList.toggle('isexist', selected);
        button.classList.toggle('wishlistwvt', !selected);
        button.setAttribute('aria-pressed', String(selected));
        button.setAttribute('type', 'button');
        button.textContent = selected ? text.added : text.add;
      });
      document.querySelectorAll('.wishlist_total_count').forEach(node => { node.textContent = String(items.length); });
    };
    const element = (tag, className, content) => {
      const node = document.createElement(tag);
      node.className = className;
      if (content) node.textContent = content;
      return node;
    };
    const render = items => {
      const version = ++generation;
      if (!listRoot) return;
      listRoot.replaceChildren();
      const status = element('p', 'hs-wishlist__status', storageError ? text.error : items.length ? text.loading : text.empty);
      status.setAttribute('role', 'status');
      listRoot.append(status);
      if (storageError || !items.length) return;
      const list = element('ul', 'hs-wishlist__list');
      listRoot.append(list);
      const requests = items.map(async item => {
        const row = element('li', 'hs-wishlist__item');
        const detail = element('div', 'hs-wishlist__detail', text.loading);
        const remove = element('button', 'hs-wishlist__remove', text.remove);
        remove.type = 'button';
        remove.dataset.wishlistRemove = item.ProductId;
        row.append(detail, remove);
        list.append(row);
        try {
          const response = await fetch(root + 'products/' + encodeURIComponent(item.Producthandler) + '.js', { credentials: 'same-origin' });
          if (!response.ok) throw new Error('Product unavailable');
          const product = await response.json();
          if (version !== generation) return;
          const link = element('a', 'hs-wishlist__product');
          link.href = root + 'products/' + encodeURIComponent(item.Producthandler);
          const imageSrc = product.featured_image || product.images[0];
          if (imageSrc) {
            const image = element('img', 'hs-wishlist__image');
            const imageUrl = new URL(imageSrc, location.origin);
            if (imageUrl.protocol === 'https:') image.src = imageUrl.href;
            image.alt = product.title;
            image.width = 160;
            image.height = 160;
            image.loading = 'lazy';
            link.append(image);
          }
          link.append(element('span', 'hs-wishlist__title', product.title));
          const price = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: text.currency }).format(product.price / 100);
          const view = element('a', 'hs-wishlist__view', text.view);
          view.href = link.href;
          detail.replaceChildren(link, element('p', 'hs-wishlist__price', price), view);
          remove.setAttribute('aria-label', text.remove + ': ' + product.title);
        } catch (_) { if (version === generation) detail.textContent = text.unavailable; }
      });
      Promise.all(requests).then(() => { if (version === generation) status.textContent = ''; });
    };
    const refresh = () => { const items = read(); updateButtons(items); render(items); };
    document.addEventListener('click', event => {
      if (!(event.target instanceof Element)) return;
      const button = event.target.closest(selector);
      const remove = event.target.closest('[data-wishlist-remove]');
      if (!button && !remove) return;
      event.preventDefault();
      const items = read();
      if (storageError) { if (button) button.textContent = text.error; return; }
      const id = button ? button.getAttribute('product_id') : remove.dataset.wishlistRemove;
      const selected = items.some(item => item.ProductId === id);
      const next = items.filter(item => item.ProductId !== id);
      if (button && !selected) next.push({ ProductId: id, Producthandler: button.getAttribute('product_handler') });
      try { localStorage.setItem(key, JSON.stringify(next)); }
      catch (_) { if (button) button.textContent = text.error; return; }
      updateButtons(next);
      render(next);
    });
    window.addEventListener('storage', event => { if (event.key === key || event.key === null) refresh(); });
    document.addEventListener('shopify:section:load', () => updateButtons(read()));
    refresh();
  })();
  } catch(e) { console.error(e); }
})();

})();
